import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const CartIcon = ({
  title = 'Cart',
  viewBox = '0 0 16 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" d="M3.45 1.047a.857.857 0 00-.825-.664H.879C.434.41.082.797.082 1.27v.05c.027.47.395.84.848.84h.996l1.847 9.945.012.051c.094.39.434.668.82.668h1.7c-.782 0-1.414.664-1.414 1.485 0 .816.632 1.48 1.414 1.48.78 0 1.414-.664 1.414-1.48 0-.82-.633-1.485-1.414-1.485h4.804c-.777 0-1.414.664-1.414 1.485 0 .816.637 1.48 1.414 1.48.782 0 1.414-.664 1.414-1.48 0-.82-.632-1.485-1.414-1.485h1.75c.446-.027.797-.414.797-.886v-.055c-.027-.465-.394-.836-.847-.836H5.305l-.11-.594h7.668a.852.852 0 00.727-.543l2.262-5.629.02-.047c.194-.574-.212-1.187-.802-1.187H3.82l-.36-1.945zm.702 3.777l.715 3.852h7.38l1.546-3.852zm0 0" />
  </CreateIconComponent>
);

export default CartIcon;
